export const ACCEPTED_TYPES = {
  "application/pdf": [],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
  "application/vnd.ms-excel": [],
};

export const EXCEL_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx (newer Excel format Office 2007+)
  "application/vnd.ms-excel", // .xls ( (legacy Office 97–2003 binary format)
];

export const MAX_TOTAL_UPLOAD_SIZE_BYTES = 450 * 1024 * 1024; // 450 MB — BE hard limit is 500 MB

export const DEFAULT_SITE_ID = 0;

export const SERVER_LIMIT_EXCEEDED_ERROR_MESSAGE = "Total file size exceeds the server limit. Please reduce your selection.";
